import axios from '@/utils/request';
const v1 = 'v1/admin';

export const getClients = () => axios.get(`${v1}/clients/index`);
export const getCompanyClients = (id) => axios.get(`${v1}/company/${id}/clients`);
export const updateClient = (data) => axios.post(`${v1}/clients/update`, data);
export const deleteClient = (id) => axios.post(`${v1}/clients/delete`, id);
